<template>
    <div
        id="buy-back-price-box"
        class="rounded overflow-hidden mb-4"
    >
        <SectionTitle :title="$t('products.buy_back')"/>

        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start m-0 mt-4 m-md-4 mb-">
            <span
                class="h2 fw-bold order-1 order-md-2 text-start text-md-end mb-3 mb-md-0"
                v-if="store.product.buy_back_price > 0"
            >
                {{ $formatter.price(store.product.buy_back_price) }}
              </span>
            <div class="order-2 order-md-1 w-100 w-md-75 me-0 me-md-3">
                <p class="mb-2">
                    {{ $t('products.buy_back_text') }}
                </p>
                <p class="mb-0">
                    {{ $t('products.buy_back_subtext') }}
                </p>
            </div>
        </div>

        <div class="pt-3 ms-0 ms-md-4">
            <a
                :href="`mailto:${settingsStore.get('settings.contact_email')}?subject=Buyback inquiry`"
                class="btn btn-lg btn-primary w-auto"
            >
                {{ $t('products.buy_back_button') }}
            </a>
        </div>
    </div>
</template>

<script setup>
import SectionTitle from '~/components/Product/SectionTitle.vue'

const store = useProductPageStore();
const settingsStore = useSettingsStore();
</script>
